import {environment} from '../../../environments/environment';

export class BaseException {
    public statuses: number[];
    public messages: string[];

    constructor(statuses: number[], messages: string[]) {
        if (!environment.production) {
            console.error('*******Exception*********');
            if (statuses.length > 0) {
                console.error('status: ', ...statuses);
            }
            console.error('messages: ', ...messages);
            console.error('*************************');
        }

        this.statuses = statuses;
        this.messages = messages;
    }
}
